import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full py-28 md:py-36 flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Fashion%20boutique%20interior%20with%20clothing%20racks%20and%20shelves%20filled%20with%20stylish%20garments%20warm%20ambient%20lighting%20through%20large%20windows%20editorial%20fashion%20photography%20cream%20beige%20terracotta%20and%20sage%20green%20tones%20clean%20minimalist%20aesthetic%20high%20detail%20no%20text%20no%20logos&width=1600&height=800&seq=oopbuy-cta-bg-002&orientation=landscape"
        alt="OOPBuy Spreadsheet – Jetzt entdecken und Produkte vergleichen"
        title="OOPBuy Spreadsheet – Jetzt entdecken"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 text-center px-6 max-w-2xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
          Bereit für dein OOPBuy Spreadsheet?
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-10 max-w-lg mx-auto leading-relaxed">
          Entdecke jetzt alle Kategorien, vergleiche Produkte und finde die besten OOPBuy
          Spreadsheet Angebote für deutsche Nutzer.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-white font-bold text-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-shopping-bag-line text-xl"></i>
          <span>Buy It Now</span>
          <i className="ri-arrow-right-up-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}